import { parseURI as parseWSURI } from '@cian/chats-api/lib/browser/websocket/uri';

import { IApplicationContext } from '../../shared/types/applicationContext';
import { EventChannel, TSocketState } from '../../shared/types/socket';

/**
 * Переходная функция для выноса сокетов из стейта. В идеальной архитектуре должно быть так https://www.taniarascia.com/websockets-in-redux/
 * @param context Контекст приложения, который расширяется сокетами
 */
export function attachSocketToContext(context: IApplicationContext) {
  const chatsBaseWsApi = context.config.getStrict<string>('chats.webSocketUrl');

  const baseWSUri = parseWSURI(chatsBaseWsApi);

  /* istanbul ignore if */
  if (!baseWSUri) {
    context.logger.error('Incorrect WS URI', { chatsBaseWsApi });
    throw new Error('Incorrect WS URI');
  }

  const eventChannel = new EventChannel({
    baseWSUri,
    apiMethodPath: 'v3/endpoint-desktop/',
  });

  const socket: TSocketState = {
    clientEvents: new Map(),
    eventChannel: eventChannel as EventChannel,
  };

  context.custom.socket = socket;
}
